export const APP_NETWORK_EVENT = 'gem:network-status';
export const APP_PWA_UPDATE_EVENT = 'gem:pwa-update-available';

export const emitRuntimeEvent = (eventName, detail = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};
